import React, { useState } from 'react';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'General Inquiry',
    message: ''
  });
  
  const [submitted, setSubmitted] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real implementation, this would send the form data to a server
    console.log('Form submitted:', formData);
    setSubmitted(true);
  };
  
  return (
    <div className="container page-container">
      <h1>Contact Us</h1>
      <p>Have questions about the campaign or want to get involved? Reach out to us using the form below.</p>
      
      {submitted ? (
        <div className="success-message" style={{
          padding: '20px',
          backgroundColor: '#e8f5e9',
          border: '1px solid #a5d6a7',
          borderRadius: '5px',
          marginTop: '20px'
        }}>
          <h2>Thank you for your message!</h2>
          <p>We've received your inquiry and will get back to you as soon as possible.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{
          maxWidth: '600px',
          margin: '30px auto',
          backgroundColor: 'white',
          padding: '30px',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="name" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '4px',
                border: '1px solid #ddd'
              }}
            />
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="email" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '4px',
                border: '1px solid #ddd'
              }}
            />
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="subject" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Subject</label>
            <select
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '4px',
                border: '1px solid #ddd'
              }}
            >
              <option value="General Inquiry">General Inquiry</option>
              <option value="Volunteer">I Want to Volunteer</option>
              <option value="Chapter Organizing">Chapter Organizing</option>
              <option value="Coalition Building">Coalition Building</option>
              <option value="Press/Media">Press/Media</option>
            </select>
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="message" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="6"
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '4px',
                border: '1px solid #ddd',
                resize: 'vertical'
              }}
            />
          </div>
          
          <button type="submit" style={{
            backgroundColor: 'var(--primary)',
            color: 'white',
            border: 'none',
            padding: '12px 20px',
            borderRadius: '4px',
            fontWeight: '600',
            cursor: 'pointer'
          }}>
            Send Message
          </button>
        </form>
      )}
      
      <div style={{ marginTop: '40px' }}>
        <h2>Other Ways to Reach Us</h2>
        <p><strong>Email:</strong> info@votersdeservemore.org</p>
        <p><strong>Social Media:</strong> Follow us on Twitter, Facebook, and Instagram @VotersDeserveMore</p>
      </div>
    </div>
  );
};

export default ContactUs;